// React
import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { Auth, API, graphqlOperation, Hub } from "aws-amplify";
import * as queries from "./graphql/queries";
import * as subscriptions from "./graphql/subscriptions";

import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  NavLink,
  Link,
} from "react-router-dom";

// Amplify
import {
  // AmplifyAuthContainer,
  AmplifyAuthenticator,
  AmplifySignUp,
  AmplifySignIn,
  AmplifySignOut,
} from "@aws-amplify/ui-react";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";

import PubSub from "@aws-amplify/pubsub";
import awsmobile from "./aws-exports";
import Amplify from "@aws-amplify/core";

// Material-ui
import {
  Typography,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Divider,
  ListItem,
  ListItemText,
  IconButton,
  CssBaseline,
  colors,
} from "@material-ui/core";
import SwitchButton from "@material-ui/core/Switch";

// Material-uiスタイル
import {
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes,
  makeStyles,
} from "@material-ui/core/styles";

// Material-uiアイコン
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import HomeIcon from "@material-ui/icons/Home";
import DescriptionIcon from "@material-ui/icons/Description";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import GetAppIcon from "@material-ui/icons/GetApp";

// 翻訳
import { I18n } from "@aws-amplify/core";
import { vocabularies } from "./dictionary.js";

// コンテナ
import Home from "./containers/Home";
import Start from "./containers/Start";
import Manual from "./containers/Manual";
import Profile from "./containers/Profile";
import Download from "./containers/Download";
import Thankyou from "./containers/Thankyou";
import Admin from "./containers/Admin";
import ConnectAccount from "./containers/ConnectAccount";

// コンポーネント
import Analytics from "./component/Analytics";

// Dev
import Developer from "./containers/Developer";

// サイドバー
import clsx from "clsx";

// Amplifyの設定
Amplify.configure(awsmobile);
PubSub.configure(awsmobile);

I18n.putVocabularies(vocabularies);
I18n.setLanguage("ja");

const api_name = process.env.REACT_APP_API_NAME;
var base_url = "https://new.pluselect.com";

const schoolShopList = [
  "1",
  "37",
  "4",
  "5",
  "6",
  "7",
  "8",
  "1dcf66b5-ee77-45be-b978-4f8949e65402",
];
const specialShopList = ["7", "1dcf66b5-ee77-45be-b978-4f8949e65402"];

const App = () => {
  // メインテーマ
  let light = createMuiTheme({
    palette: {
      type: "light",
      primary: {
        main: colors.grey[900],
        contrastText: colors.grey[100],
      },
      secondary: {
        main: colors.yellow[600],
        contrastText: colors.grey[900],
      },
      background: {
        default: colors.grey[50],
        paper: colors.grey[200],
      },
      text: {
        primary: colors.grey[900],
        secondary: colors.yellow[800],
      },
      info: {
        contrastText: "#fff",
        main: colors.cyan[400],
      },
      warning: {
        contrastText: "#fff",
        main: colors.orange[400],
      },
      error: {
        contrastText: "#fff",
        main: colors.red[400],
      },
      divider: colors.grey[600],
    },
    overrides: {
      MuiInputLabel: {
        root: {
          color: colors.grey[800],
        },
      },
    },
    typography: {
      fontFamily: ["Noto Sans", "sans-serif"].join(","),
    },
  });
  light = responsiveFontSizes(light);

  let dark = createMuiTheme({
    palette: {
      type: "dark",
      primary: {
        main: "#fff",
        contrastText: "#000",
      },
      secondary: {
        main: "#000",
        contrastText: "#fff",
      },
      background: {
        default: "#15202B",
        paper: "#192633",
      },
      text: {
        primary: "#fff",
        secondary: colors.yellow[800],
      },
      info: {
        contrastText: "#fff",
        main: colors.cyan[600],
      },
      warning: {
        contrastText: "#fff",
        main: colors.orange[600],
      },
      error: {
        contrastText: "#fff",
        main: colors.red[900],
      },
      divider: colors.grey[600],
    },
    overrides: {
      MuiInputLabel: {
        root: {
          color: colors.grey[400],
        },
      },
    },
    typography: {
      fontFamily: ["Noto Sans", "sans-serif"].join(","),
    },
  });
  dark = responsiveFontSizes(dark);

  const [open, setOpen] = useState(false);
  const [authState, setAuthState] = useState();
  const [authError, setAuthError] = useState();
  const [user, setUser] = useState();
  const [title, setTitle] = useState("");

  const [userInfo, setUserInfo] = useState({});
  const [userId, setUserId] = useState();
  const [userShop, setUserShop] = useState([]);
  const [userBuyma, setUserBuyma] = useState([]);
  const [userGroup, setUserGroup] = useState(["default"]);
  const [allShops, setAllShops] = useState();
  const [profile, setProfile] = useState(false);
  const [trial, setTrial] = useState();

  // Stripe
  const [customerId, setCustomerId] = useState();
  const [portalUrl, setPortalUrl] = useState();
  const [stripeParentAccount, setStripeParentAccount] = useState();

  // テーマ
  const [mode, setMode] = useState(false);
  const [theme, setTheme] = useState(light);

  // サイドバーのスタイル
  const drawerWidth = 240;
  const useStyles = makeStyles(() => ({
    root: {
      display: "flex",
    },
    appBar: {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: "flex-end",
    },
    toolbar: {
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    navlink: {
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
    },
    active: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    title: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  }));
  const classes = useStyles();

  // プロフィールが更新された時（名前の表示で必要）
  // ユーザー情報が更新された時（customerIdが必要）
  useEffect(() => {
    if (userId) {
      console.log(userId);
      API.graphql(
        graphqlOperation(subscriptions.onUpdateProfileById, {
          id: userId,
        })
      ).subscribe({
        next: ({ provider, value }) => {
          let updateProfile = value.data.onUpdateProfileById;
          setProfile(updateProfile);
        },
        error: (error) => console.warn(error),
      });

      API.graphql(
        graphqlOperation(subscriptions.onUpdateUserInfoById, {
          id: userId,
        })
      ).subscribe({
        next: ({ provider, value }) => {
          let updateUserInfo = value.data.onUpdateUserInfoById;
          setUserInfo(updateUserInfo);
          // 一回しかsubscribeしない場合
          // subscription.unsubscribe();
        },
        error: (error) => console.warn(error),
      });
      // return () => subscription.unsubscribe();
    }
  }, [userId]);

  // テーマ情報を取得
  useEffect(() => {
    let themeName = localStorage.getItem("theme");
    if (themeName === "dark") {
      setMode(true);
      setTheme(dark);
    } else if (themeName === "light") {
      setMode(false);
      setTheme(light);
    }
  }, []);

  // 紹介者のstripeアカウントを取得
  useEffect(() => {
    let stripeParentAccount = new URLSearchParams(window.location.search).get(
      "stripeParentAccount"
    );
    console.log(stripeParentAccount);
    setStripeParentAccount(stripeParentAccount);
  }, []);

  useEffect(() => {
    Hub.listen("auth", (res) => {
      if (res.payload.data) {
        const errorMsg = res.payload.data.message
          ? res.payload.data.message
          : null;
        if (vocabularies["ja"][errorMsg]) {
          setAuthError(vocabularies["ja"][errorMsg]);
        } else {
          setAuthError(errorMsg);
        }
      }
    });
  }, []);

  // 認証情報をセット
  useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      console.log(nextAuthState, authData);
      setAuthState(nextAuthState);
      setUser(authData);
      if (authData) {
        if (authData.signInUserSession) {
          // Analytics
          if (window.gtag) {
            if (nextAuthState === "confirmSignUp") {
              window.gtag("event", "sign_up", {
                method: "Cognito",
              });
            } else if (nextAuthState === "signedin") {
              window.gtag("event", "login", {
                method: "Cognito",
              });
            }
          }

          setUserId(authData.username);
          var group =
            authData.signInUserSession.accessToken.payload["cognito:groups"];
          console.log(group);
          if (group) {
            setUserGroup(group);
          }
        }
      }
    });
  }, []);

  // 全てのショップ情報取得
  useEffect(() => {
    if (userId && !allShops) {
      listShops().then((allShops) => {
        setAllShops(allShops);
        console.log("全てのショップを取得しました");
      });
    }
  }, [userId, allShops]);

  // ユーザー情報取得
  useEffect(() => {
    if (userId && !userInfo.id) {
      getUserInfo(userId).then((userInfo) => {
        console.log(userInfo);
        if (userInfo) {
          setUserInfo(userInfo);
        }
        console.log("ユーザー情報を取得しました");
      });
    }
  }, [userInfo, userId]);

  // ユーザー情報からセット
  useEffect(() => {
    if (userInfo.id) {
      if (userInfo.buyma.items) {
        setUserBuyma(userInfo.buyma.items);
      }
      if (userInfo.profile) {
        setProfile(userInfo.profile);
      }
      // 無料トライアルチェック
      if (userInfo.trial) {
        setTrial(userInfo.trial);
        let today = Date.now();
        let createdAt = new Date(userInfo.createdAt).getTime();
        let elapsed = today - createdAt;
        let elapsedhour = elapsed / 3600000;
        let remaining = Math.floor(168 - elapsedhour);
        setTitle(
          <Typography variant="caption" className={classes.title}>
            ※ トライアルは残り{remaining}時間です。
            <br />
            <Link color="textSecondary" to="/start">
              こちら
            </Link>
            のマニュアルに従って進めてください。
          </Typography>
        );
      }

      // カスタマーIDを取得
      if (userInfo.customerId) {
        setCustomerId(userInfo.customerId);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (customerId && !portalUrl) {
      createPortalSession(customerId);
    }
  }, [customerId]);

  // ユーザーショップリストをセット
  useEffect(() => {
    if (userInfo.id && allShops) {
      console.log("ユーザーショップリストをセット");
      var userShopList = userInfo.shop.items.map((res) => {
        return res.shop;
      });
      // Farfetchを追加
      const farfetchShop = allShops.filter((data) => {
        return data.id === "2";
      });
      const italistShop = allShops.filter((data) => {
        return data.id === "3";
      });
      userShopList = userShopList.concat(farfetchShop);
      userShopList = userShopList.concat(italistShop);

      // グループのショップをセット
      if (userGroup) {
        if (userGroup.includes("Administrator")) {
          setUserShop(allShops);
        } else if (userGroup.includes("School")) {
          let schoolShops = allShops.filter((data) => {
            return schoolShopList.includes(data.id);
          });
          userShopList = userShopList.concat(schoolShops);
          setUserShop(userShopList);
        } else if (userGroup.includes("Special")) {
          let specialShops = allShops.filter((data) => {
            return specialShopList.includes(data.id);
          });
          userShopList = userShopList.concat(specialShops);
          setUserShop(userShopList);
        } else {
          setUserShop(userShopList);
        }
      } else {
        setUserShop(userShopList);
      }
    }
  }, [userInfo, userGroup, allShops]);

  const createPortalSession = function (customerId) {
    var query = {
      body: {
        return_url: base_url,
        customerId: customerId,
      },
    };
    API.post(api_name, "/stripe/createCustomerPortalSession", query)
      .then((response) => {
        console.log(response);
        if (response.url) {
          console.log(response.url);
          setPortalUrl(response.url);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    setMode(e.target.checked);
    if (e.target.checked) {
      localStorage.setItem("theme", "dark");
      setTheme(dark);
    } else {
      localStorage.setItem("theme", "light");
      setTheme(light);
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const getUserInfo = (username) => {
    return new Promise(function (resolve, reject) {
      API.graphql({
        query: queries.getUserInfo,
        variables: { id: username },
        nullable: true,
      })
        .then((res) => {
          resolve(res.data.getUserInfo);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const listShops = () => {
    return new Promise(function (resolve, reject) {
      API.graphql(
        graphqlOperation(queries.listShops, {
          limit: 1000,
        })
      )
        .then((res) => {
          resolve(res.data.listShops.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const handleSignUp = async (formData) => {
    const param = {
      ...formData,
      attributes: {
        ...formData.attributes,
      },
    };
    if (stripeParentAccount) {
      param.attributes["custom:stripeParentAccount"] = stripeParentAccount;
    }
    const data = await Auth.signUp(param);
    return data;
  };

  // 認証ステータスが、サインイン状態でユーザー情報がある場合
  return (
    <div className={classes.root}>
      <HashRouter>
        <Analytics userInfo={userInfo} />
        {/* Material-UIのクラスで、アプリケーション全体のCSSテーマをセット */}
        <ThemeProvider theme={theme}>
          {/* これがないと背景の色がうまく行かない */}
          <CssBaseline />
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap>
                PLUSELECT WEB SYSTEM
              </Typography>
              {userGroup.map((e) => {
                if (e !== "default") {
                  return (
                    <Typography variant="h6" key={e}>
                      【{e}】
                    </Typography>
                  );
                }
              })}
              {title}
              <SwitchButton
                checked={mode}
                onChange={handleChange}
                name="mode"
                color="primary"
              />
            </Toolbar>
          </AppBar>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "ltr" ? (
                  <ChevronLeftIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            </div>
            <Divider />
            <List>
              <ListItem
                button
                exact
                component={NavLink}
                to="/"
                activeClassName={classes.active}
                className={classes.navlink}
              >
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="ホーム" />
              </ListItem>
            </List>
            <List>
              <ListItem
                button
                exact
                component={NavLink}
                to="/start"
                activeClassName={classes.active}
                className={classes.navlink}
              >
                <ListItemIcon>
                  <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary="はじめに" />
              </ListItem>
            </List>
            <List>
              <ListItem
                button
                exact
                component={NavLink}
                to="/manual"
                activeClassName={classes.active}
                className={classes.navlink}
              >
                <ListItemIcon>
                  <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary="マニュアル" />
              </ListItem>
            </List>
            <Divider />
            <List>
              <ListItem
                button
                exact
                component={NavLink}
                activeClassName={classes.active}
                className={classes.navlink}
                to="/profile"
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary="プロフィール" />
              </ListItem>
            </List>
            <List>
              <ListItem
                button
                exact
                component={NavLink}
                activeClassName={classes.active}
                className={classes.navlink}
                to="/download"
              >
                <ListItemIcon>
                  <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="ダウンロード" />
              </ListItem>
            </List>
            {userGroup.includes("Administrator") ? (
              <>
                <List>
                  <ListItem
                    button
                    exact
                    component={NavLink}
                    activeClassName={classes.active}
                    className={classes.navlink}
                    to="/developer"
                  >
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="開発者" />
                  </ListItem>
                </List>
                <List>
                  <ListItem
                    button
                    exact
                    component={NavLink}
                    activeClassName={classes.active}
                    className={classes.navlink}
                    to="/admin"
                  >
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="管理者" />
                  </ListItem>
                </List>
              </>
            ) : null}
            {userInfo.stripeAccount ? (
              <List>
                <ListItem
                  button
                  exact
                  component={NavLink}
                  activeClassName={classes.active}
                  className={classes.navlink}
                  to={`/connect/${userInfo.stripeAccount}`}
                >
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="アフィリエイト" />
                </ListItem>
              </List>
            ) : (
              <List>
                <ListItem
                  button
                  exact
                  component={NavLink}
                  activeClassName={classes.active}
                  className={classes.navlink}
                  to={"/connect/create"}
                >
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="アフィリエイト" />
                </ListItem>
              </List>
            )}
            <Divider />
            <AmplifySignOut />
          </Drawer>
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <div className={classes.toolbar} />
            <Typography color="error" variant="h3">
              {authError}
            </Typography>
            {/* 認証チェック */}
            {authState === AuthState.SignedIn && user ? (
              <Switch>
                {/* 配下のRouteのうち、どれか一つにマッチしたらそれのみをレンダリング(Switchなしだとマッチしたもの全てがレンダリングされる) */}
                <Route
                  exact
                  path="/"
                  render={() => (
                    <Home
                      userGroup={userGroup}
                      userInfo={userInfo}
                      userShop={userShop}
                      userBuyma={userBuyma}
                      profile={profile}
                      trial={trial}
                      userId={userId}
                      customerId={customerId}
                      portalUrl={portalUrl}
                    />
                  )}
                />
                <Route exact path="/start" render={() => <Start />} />
                <Route
                  exact
                  path="/manual"
                  render={() => <Manual userInfo={userInfo} />}
                />
                <Route
                  exact
                  path="/developer"
                  render={() => (
                    <Developer userGroup={userGroup} allShops={allShops} />
                  )}
                />
                <Route
                  exact
                  path="/admin"
                  render={() => (
                    <Admin userGroup={userGroup} userInfo={userInfo} />
                  )}
                />
                <Route
                  exact
                  path="/profile"
                  render={() => (
                    <Profile
                      userInfo={userInfo}
                      profile={profile}
                      userBuyma={userBuyma}
                      userShop={userShop}
                      portalUrl={portalUrl}
                    />
                  )}
                />
                <Route
                  exact
                  path="/download"
                  render={() => <Download userInfo={userInfo} />}
                />
                <Route
                  exact
                  path="/connect/:accountID"
                  render={() => <ConnectAccount userInfo={userInfo} />}
                />
                <Route
                  exact
                  path="/thankyou/:session_id"
                  render={(props) => (
                    <Thankyou {...props} userInfo={userInfo} />
                  )}
                />
                <Redirect path="*" to="/" />
              </Switch>
            ) : (
              <AmplifyAuthenticator
                slot="amplify-authenticator"
                usernameAlias="email"
              >
                <AmplifySignUp
                  slot="sign-up"
                  usernameAlias="email"
                  formFields={[
                    {
                      type: "email",
                      label: "Eメールアドレス *",
                      placeholder: "Eメール",
                      required: true,
                    },
                    {
                      type: "password",
                      label: "パスワード *",
                      placeholder: "パスワード",
                      required: true,
                    },
                  ]}
                  handleSignUp={handleSignUp}
                />
                <AmplifySignIn slot="sign-in" usernameAlias="email" />
              </AmplifyAuthenticator>
            )}
          </main>
        </ThemeProvider>
      </HashRouter>
    </div>
  );
};

export default App;
